import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { FONT_BASE_COLOR, OUTLINE_COLOR } from '@CSSVars/colors'
import Dropdown from 'Components/Dropdown'

export const _FrequencySelect = styled(Dropdown).attrs({
  className: 'frequencySelect',
})`
  .dropdown {
    padding: 0 !important;
    svg {
      fill: ${FONT_BASE_COLOR};
    }

    div:last-of-type {
      border-bottom: none;
    }
  }
`

export const _Item = styled.div`
  position: relative;
  list-style-type: none;
  padding: 16px;
  height: 48px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${OUTLINE_COLOR};
`

export const _FrequencyLabel = styled.button`
  border: none;
  padding-left: 10px;
  &:focus {
    outline: 0.5px solid grey;
  }
`
